<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    아이템 상세정보
                </div>
              <div class="write_tab">
                <div class="write_tab_content tab_payment_detail" @click="moveDetail()">
                  상세정보
                </div>
                <div class="write_tab_content tab_payment_detail active"
                     >
                  유틸리티
                </div>
              </div>
              <div class="member_write_wrap">
                <div class="write_content">
                  <div class="write_box">
                    <utility-list-item-component :utilityType="`itemUtility`" :itemKey="itemKey"></utility-list-item-component>
                  </div>
                </div>
              </div>
            </div>
        </div>

    </div>
</template>

<script>
import UtilityListItemComponent from "@/components/utility/UtilityListItemComponent";

export default {
    name: "ItemDetailUtility",
    mixins: [],
    components: {
      UtilityListItemComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            itemKey: this.$route.params.idx
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
      moveDetail() {
        this.$router.push(`/item/list/${this.itemKey}`)
      },
    },
    watch: {},
}
</script>

<style scoped>

</style>
